const TEXT = {
    TRANSFER_CONTENT_TEXT_1:"我要充值",
    TRANSFER_CONTENT_TEXT_2:"公司账户",
    TRANSFER_CONTENT_TEXT_3:"请选择公司账户",
    TRANSFER_CONTENT_TEXT_4:"充值金额",
    TRANSFER_CONTENT_TEXT_5:"请输入充值金额",
    TRANSFER_CONTENT_TEXT_6:"充值凭证",
    TRANSFER_CONTENT_TEXT_7:"上传文件",
    TRANSFER_CONTENT_TEXT_8:"确认提交",
    TRANSFER_CONTENT_TEXT_9:"确认",
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/transfer/index.js